var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassportIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_4222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 24H40V27H26V24ZM26 19H40V22H26V19ZM26 29H40V32H26V29ZM42 8H6C3.8 8 2 9.8 2 12V38C2 40.2 3.8 42 6 42H42C44.2 42 46 40.2 46 38V12C46 9.8 44.2 8 42 8ZM42 38H24V12H42V38Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_4222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassportIcon);
export default __webpack_public_path__ + "static/media/PassportIcon.462d9610b83c94bf38aa9a1195434d39.svg";
export { ForwardRef as ReactComponent };